import { render } from "./ByApplicantEditModal.vue?vue&type=template&id=07894c8c"
import script from "./ByApplicantEditModal.vue?vue&type=script&lang=js"
export * from "./ByApplicantEditModal.vue?vue&type=script&lang=js"

import "./ByApplicantEditModal.vue?vue&type=style&index=0&id=07894c8c&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__